<div class="account-settings" [formGroup]="accountFg">
  <div class="account-header">
    <h3 class="account-title">Account</h3>
    <p class="account-description">Manage your account settings.</p>
  </div>
  <div class="account-content">
    <div class="form-section">
      <div class="form-group">
        <span class="input-label">Email</span>
        <mat-form-field appearance="outline">
          <input matInput formControlName="email" placeholder="Email" required>
          @if (accountFg.get('email').invalid &&
            accountFg.get('email').touched &&
            accountFg.get('email')?.hasError('required')) {
            <mat-error
              >
              Email is required
            </mat-error>
          }

          @if (accountFg.get('email').invalid &&
            accountFg.get('email').touched &&
            accountFg.get('email')?.hasError('pattern')) {
            <mat-error
              >
              Email is invalid
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="form-group">
          <span class="input-label">First Name</span>
          <mat-form-field appearance="outline">
            <input matInput formControlName="first_name" placeholder="First Name" required>
            @if (accountFg.get('first_name').invalid &&
              accountFg.get('first_name').touched &&
              accountFg.get('first_name')?.hasError('required')) {
              <mat-error
                >
                First Name is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-group">
          <span class="input-label">Last Name</span>
          <mat-form-field appearance="outline">
            <input matInput formControlName="last_name" placeholder="Last Name" required>
            @if (accountFg.get('last_name').invalid &&
              accountFg.get('last_name').touched &&
              accountFg.get('last_name')?.hasError('required')) {
              <mat-error
                >
                Last Name is required
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="account-actions">
    <button mat-button class="frmg-primary-button"
      (click)="saveChanges()" [disabled]="accountFg.invalid || !accountFg.dirty">Save Changes
    </button>
  </div>
</div>